import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MESSAGES } from '../consts/messages';
import { AppError } from '../errors/app-error';
import { MessageHelper, MessageTypeEnum } from './message.helper';

@Injectable({ providedIn: 'root' })
export class ErrorHelper {
  constructor(private messageHelper: MessageHelper) {}

  catch(err: any, messages: any = {}) {
    console.error('ErrorHelper -->', err);
    const type = MessageTypeEnum.error;
    if (err instanceof AppError) this.messageHelper.send(err.message, type);
    else if (err instanceof HttpErrorResponse) {
      if (err.error instanceof Array) {
        this.messageHelper.send(err.error.join(), type);
      } else {
        this.messageHelper.send(
          messages[err.status] || MESSAGES[err.status],
          type
        );
      }
    }
    else if (typeof err == 'string')
        this.messageHelper.send(err, type);
    else this.messageHelper.send(MESSAGES.unexpectedError, type);
  }
}
